import styled from '@emotion/styled'
import HeroImage from '../../../../assets/hero.png'

export const Left = styled.div`
  background: url(${HeroImage});
  background-size: contain;
  background-repeat: no-repeat;
  flex-basis: 50%;
  display: flex;
  justify-content: flex-start;
  min-height: 626px;

  @media (max-width: 768px) {
    min-height: 401px;
    width: 100%;
  }
`
